import { Typography, useTheme } from '@mui/material';
import { useMemo } from 'react';
import './ratio_gauge.css';

const TOTAL_LENGTH = 329.9;

export const RatioGauge = ({ value, suffix = '' }: { value?: number; suffix?: string }) => {
  const theme = useTheme();

  // Memoize these calculations to prevent recalculation on each render
  const { label, color, needleColor, gaugeDash, needleRotation } = useMemo(() => {
    const getColor = (val?: number) => {
      if (val == null) return theme.palette.text.disabled;
      if (val >= 80) return theme.palette.error.main;
      if (val >= 50) return theme.palette.warning.main;
      return theme.palette.success.main;
    };
    const getNeedleColor = (val?: number) => {
      if (val && val >= 80) return theme.palette.error.main;
      return theme.palette.common.white;
    };

    return {
      label: value != null ? value.toFixed(1) : '--.--',
      color: getColor(value),
      needleColor: getNeedleColor(value),
      gaugeDash: `${TOTAL_LENGTH} 0`,
      // needle rotation (0% = -135deg, 100% = 135deg)
      needleRotation: `rotate(${-135 + ((value || 0) / 100) * 270}, 100, 115)`,
    };
  }, [value, theme]);

  return (
    <span className="ratio_gauge">
      <span className="gauge">
        <svg viewBox="0 0 200 200">
          <title>Ratio Gauge</title>
          <defs>
            <linearGradient id="gauge-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#74AF65" />
              <stop offset="50%" stopColor="#B07C4E" />
              <stop offset="100%" stopColor="#E64F3B" />
            </linearGradient>
          </defs>
          <path className="gauge-background" d="M40,150 A70,70 0 1,1 160,150" stroke={theme.palette.background.default} />
          <path
            className="gauge-value"
            d="M40,150 A70,70 0 1,1 160,150"
            stroke="url(#gauge-gradient)"
            strokeDasharray={gaugeDash}
          />
          {/*For SVG elements, we need to use transform attribute with rotate, rotation is around the center point*/}
          <line className="needle" x1="100" y1="115" x2="100" y2="65" transform={needleRotation} stroke={needleColor} />
          <circle className="needle-center" cx="100" cy="115" r="15" fill={needleColor} stroke={needleColor} />
        </svg>
      </span>
      <Typography component="span" textAlign="end" variant="h6" color={color}>
        {label}
        {suffix}
      </Typography>
    </span>
  );
};
